import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
type LightboxProps = {
  open: boolean;
  src: string;
  alt: string;
  onClose: () => void;
};
export function Lightbox({
  open,
  src,
  alt,
  onClose
}: LightboxProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);
  return <AnimatePresence data-id="element-80" data-mp="61hv6e6zgk7q">
      {open && <motion.div role="dialog" aria-modal="true" aria-label="Imagen ampliada" className="fixed inset-0 z-[60] flex items-center justify-center bg-black/95 p-3" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} onClick={onClose} data-id="element-81" data-mp="5z5iogjzv222">
          <button type="button" onClick={onClose} aria-label="Cerrar imagen" autoFocus className="absolute right-4 top-4 flex h-11 w-11 items-center justify-center rounded-full border border-gold/40 bg-ink/80 text-gold focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-82" data-mp="1z91hiskko4ya">
            <XIcon className="h-5 w-5" data-id="element-83" data-mp="2i2niq6pwkig4" />
          </button>
          <motion.img src={src} alt={alt} className="max-h-full max-w-full rounded-xl object-contain" initial={{
        scale: 0.96
      }} animate={{
        scale: 1
      }} exit={{
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} onClick={e => e.stopPropagation()} data-id="element-84" data-mp="2dzihs8lh0otl" />
        </motion.div>}
    </AnimatePresence>;
}